export class SendOtpToEmail {
  static readonly type = '[Auth] Send otp to email';
  constructor(public email: string, public domain: string) {}
}

export class CreateUser {
  static readonly type = '[Auth] Create user';
  constructor(public email: string, public domain: string) {}
}

export class VerifyOtp {
  static readonly type = '[Auth] Verify otp';
  constructor(public email: string, public otpCode: string) {}
}

export class AuthGoogle {
  static readonly type = '[Auth] Auth google';
}

export class GoogleAuthorize {
  static readonly type = '[Auth] Google authorize';
  constructor(public code: string) {}
}

export class AuthFacebook {
  static readonly type = '[Auth] Auth facebook';
}

export class FacebookAuthorize {
  static readonly type = '[Auth] Facebook authorize';
  constructor(public code: string) {}
}
